var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline d-flex align-center" },
            [
              _c("v-icon", { attrs: { left: "", color: "orange" } }, [
                _vm._v("mdi-clock-outline"),
              ]),
              _vm._v(" Em Breve "),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("div", { staticClass: "body-1 mb-3" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.message ||
                        "Esta funcionalidade está sendo desenvolvida e estará disponível em breve."
                    ) +
                    " "
                ),
              ]),
              _vm.featureName
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-0",
                      attrs: { type: "info", dense: "", text: "" },
                    },
                    [
                      _c("strong", [_vm._v("Funcionalidade:")]),
                      _vm._v(" " + _vm._s(_vm.featureName) + " "),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: { click: _vm.close },
                },
                [_vm._v(" Entendi ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }